import { render, staticRenderFns } from "./WorkflowInfo.vue?vue&type=template&id=a1faa964&scoped=true&"
import script from "./WorkflowInfo.vue?vue&type=script&lang=js&"
export * from "./WorkflowInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1faa964",
  null
  
)

export default component.exports